import { getPaymentIntent, getPayoutMethod } from "../../services/api";
import {
  formatMethodsForPaymentIntent,
  formatMethodsForPayoutIntent,
} from "./utils";

export const sdkGetIntentMethods = async ({
  intentType,
  intentId,
  lang,
}: {
  intentId: string;
  lang: string;
  intentType: "payment" | "payout";
}) => {
  if (intentType === "payment") {
    return formatMethodsForPaymentIntent(
      await getPaymentIntent(intentId, lang)
    );
  }
  return formatMethodsForPayoutIntent(await getPayoutMethod(intentId, lang));
};
